import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startCopyFlartStatus: 'idle',
    startCopyFlartError: undefined as any,
    loadUserParamsCopyFlartStatus: 'idle',
    loadUserParamsCopyFlartError: undefined as any,

    copyFlartList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startCopyFlart = createAsyncThunk('copyFlartSlice/startCopyFlart', async ({ copyFlart }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartCopyFlart/`,
        prepareData(copyFlart),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startCopyFlartStatus } = getState().copyFlartSlice
        return startCopyFlartStatus !== 'pending'
    }
})

export const loadUserParamsCopyFlart = createAsyncThunk('copyFlartSlice/loadUserParamsCopyFlart', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsCopyFlart/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsCopyFlartStatus } = getState().copyFlartSlice
        return loadUserParamsCopyFlartStatus !== 'pending'
    }
})

const CopyFlartSlice = createSlice({
    name: 'copyFlartSlice',
    initialState,
    reducers: {
        resetstartCopyFlart: (state) => {
            state.job = undefined
            state.startCopyFlartError = undefined
        },
        resetstartCopyFlartError: (state) => {
            state.startCopyFlartError = undefined
        },
        resetloadUserParamsCopyFlart: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsCopyFlartError = undefined
        },
        resetloadUserParamsCopyFlartError: (state) => {
            state.loadUserParamsCopyFlartError = undefined
        },
        removeFromCopyFlartListById: (state, action) => {
            state.copyFlartList = state.copyFlartList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromCopyFlartListByIds: (state, action) => {
            state.copyFlartList = state.copyFlartList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.copyFlartList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startCopyFlartStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.copyFlartList = []
            state.startCopyFlartStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startCopyFlart.pending, (state) => {
            state.startCopyFlartStatus = 'pending'
            state.startCopyFlartError = undefined
        })
        builder.addCase(startCopyFlart.fulfilled, (state, action) => {
            state.startCopyFlartStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startCopyFlart.rejected, (state, action) => {
            state.startCopyFlartStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startCopyFlartError = action.error.message
            } else {
                state.startCopyFlartError = action.payload
            }
        })

        builder.addCase(loadUserParamsCopyFlart.pending, (state) => {
            state.loadUserParamsCopyFlartStatus = 'pending'
            state.loadUserParamsCopyFlartError = undefined
        })
        builder.addCase(loadUserParamsCopyFlart.fulfilled, (state, action) => {
            state.loadUserParamsCopyFlartStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsCopyFlart.rejected, (state, action) => {
            state.loadUserParamsCopyFlartStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsCopyFlartError = action.error.message
            } else {
                state.loadUserParamsCopyFlartError = action.payload
            }
        })

    }
})

export const {
    resetstartCopyFlart,
    resetstartCopyFlartError,
    resetloadUserParamsCopyFlart,
    resetloadUserParamsCopyFlartError,
    removeFromCopyFlartListById,
    removeFromCopyFlartListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = CopyFlartSlice.actions
export default CopyFlartSlice.reducer
